import { useCallback } from "react";
import { DocumentData, DocumentSnapshot } from "firebase/firestore";
import { FormControl, Switch } from "native-base";

type Props = {
  fieldPath: string;
  label?: string;
  checkboxLabel?: string;
  doc: DocumentSnapshot<DocumentData>;
  updateDoc: (data: any) => Promise<void>;
  isDisabled?: boolean;
};

export default function CheckboxFormInput({
  fieldPath,
  label,
  doc,
  updateDoc,
  isDisabled,
}: Props) {
  const defaultValue = doc.get(fieldPath);

  const onToggle = useCallback(
    (newValue: boolean) => {
      updateDoc({ [fieldPath]: newValue });
    },
    [updateDoc, fieldPath],
  );

  return (
    <FormControl mb="1">
      {label && <FormControl.Label>{label}</FormControl.Label>}

      <Switch
        isChecked={Boolean(defaultValue ?? false)}
        onToggle={onToggle}
        isDisabled={isDisabled}
      />
    </FormControl>
  );
}
